<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<div class="row">
			<div class="col-md-12 text-right">
				<!-- <a-button class="btn btn-info btn-purple" icon="plus" @click="onAddRecordCash()">Añadir</a-button> -->
				<a-button class="btn btn-info ml7" icon="plus" @click="onAddRecord()">Añadir</a-button>
				<a-button class="btn btn-success ml7" icon="reload" @click="initModule" />
			</div>
			<div class="col-md-12 mt10">
				<a-input allowClear v-model="searchText" @change="onSearch" placeholder="Ingresa parámetros de búsqueda" />
			</div>
		</div>
		<div class="row pt10">
			<div class="col-md-12">
				<a-table :columns="columns" :dataSource="searchText == '' ? suppliersList : suppliersListFiltered" rowKey="id">
					<div slot="tradename" slot-scope="record">
						<div>#{{ record.id }} - {{ record.tradename }}</div>
						<div>{{ record.business_name }}</div>
						<div style="text-transform: lowercase !important" v-if="record.email"><i class="fa fa-envelope"></i> {{ record.email }}</div>
						<div v-if="record.phone_number"><i class="fa fa-phone"></i> {{ record.phone_number }}</div>
						<div v-if="record.contact_name"><i class="fa fa-user"></i> {{ record.contact_name }}</div>
						<!-- <div>{{ record }}</div> -->
					</div>
					<div slot="action" slot-scope="record">
						<a-button type="info" size="small" icon="edit" @click="onEditRecord(record.id)" />
						<a-button class="btn btn-small btn-danger ml7" size="small" icon="delete" @click="onDeleteRecord(record.id)" />
					</div>
				</a-table>
			</div>
		</div>
	</a-spin>
</template>

<script>
import { mapGetters } from 'vuex'
import utilities from '@/services/utilities'
import Swal from 'sweetalert2'

export default {
	name: 'Suppliers',
	data() {
		return {
			searchText: '',
			columns: [
				{
					title: 'Proveedor',
					scopedSlots: { customRender: 'tradename' },
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'right',
				},
			],
			suppliersListFiltered: [],
		}
	},
	computed: {
		...mapGetters('suppliers', ['suppliersList', 'spinnerLoaderLabel', 'spinnerLoader']),
	},
	mounted() {
		this.initModule()
	},
	methods: {
		initModule() {
			this.$store.dispatch('suppliers/GET')
		},
		onAddRecord() {
			this.$store.dispatch('suppliers/NEW')
		},
		onAddRecordCash() {
			Swal.fire({
				title: 'Ingresa nombre',
				input: 'text',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'Cancelar',
				inputValidator: (value) => {
					if (!value) {
						return 'Es encesario ingresar nombre'
					}
				},
			}).then((result) => {
				if (result.isConfirmed) {
					//
					let payload = {
						foreign_supplier: 0,
						tradename: result.value.toUpperCase(),
						email: '',
						phone_number: '',
						tax_regime: '',
						business_name: result.value.toUpperCase(),
						rfc: '',
						payment_methods: [{ payment_method: '1', banking_institution: -1, bankName: '- No aplica -' }],
					}
					this.$store.dispatch('suppliers/CREATE', { payload, redirect: false })
				}
			})
		},
		onEditRecord(id) {
			this.$store.dispatch('suppliers/GET_ONE', id)
		},
		onLinkPress(string) {
			if (utilities.isValidURL(string)) {
				window.open(string)
			} else {
				Swal.fire({
					title: 'Proveedores',
					html: 'El link parece no tener una estructura correcta',
					icon: 'warning',
					confirmButtonText: 'Ok',
				})
			}
		},
		onSearch(event) {
			let { value } = event.target
			this.suppliersListFiltered = []
			if (value != '') {
				value = value.toLowerCase()
				this.suppliersListFiltered = this.suppliersList.filter((obj) =>
					Object.values(obj).some((val) => {
						if (typeof val == 'string' && val.toLowerCase().includes(value)) {
							return true
						}
					}),
				)
			}
		},
		onDeleteRecord(id) {
			Swal.fire({
				title: 'Atención',
				html: `¿Deseas eliminar el registro?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					//
					this.$store.dispatch('suppliers/DELETE', {
						id,
					})
				}
			})
		},
	},
	watch: {
		suppliersList: {
			deep: true,
			handler(newData) {
				this.searchText = ''
			},
		},
	},
}
</script>